/**
 * JRE
 */
export const SET_CAPTIONS_FLAG = 'SET_CAPTIONS_FLAG';
export const SET_PAUSE_FLAG = 'SET_PAUSE_FLAG';
export const SAVE_ANSWER = 'SAVE_ANSWER';
export const SAVE_ANSWERS = 'SAVE_ANSWERS';
export const SET_ANSWERS = 'SET_ANSWERS';
export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const CLEAR_FLASH_MESSAGE = 'CLEAR_FLASH_MESSAGE';
export const SET_CURRENT_MY_ASSIGNMENT = 'SET_CURRENT_MY_ASSIGNMENT';
export const SET_CURRENT_USERS = 'SET_CURRENT_USERS';
export const REINITIALIZE_STORE_STATE = 'REINITIALIZE_STORE_STATE';



// WEBPACK FOOTER //
// ./src/js/actions/types.js